export interface Option {
  label: string;
  value: OptionValue;
}

export type OptionValue = string | number;

export type Nullable<T> = T | null;

export type ValidValue<T> = Exclude<T, null | undefined | 0 | '' | false>;

export type FormHandle = {
  submit: () => void;
};

export type RTKQueryError = {
  data: {
    errorDescription?: ErrorDescription | string;
  };
};

export interface ErrorDescription {
  key: string;
  values: Nullable<string[]>;
}

export enum LanguageCodes {
  English = 44,
  German = 49,
}
